import InfoBlockList from "./InfoBlockList";

import "./InfoBlockList.scss";

export * from "./InfoBlockList.types";

export { InfoBlockList };
